
export type CreateTweetJson202 = {
  /** ID of the created tweet */
  tweetId: string;
};
